export class DigitalCertificatesFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getCertificates() {
    return this.instance.get('/v1/nfe/certificados');
  }

  deleteCertificate(certificateId) {
    return this.instance.delete(`/v1/nfe/certificados/${certificateId}`);
  }

  deactivateCertificate(certificateId) {
    return this.instance.put(`/v1/nfe/certificados/${certificateId}/desativar`);
  }

  salvarCertificado(formData) {
    return this.instance.post('/v1/nfe/certificados/consulta', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  consultarSefaz(data) {
    return this.instance.post('/v1/nfe/consultar', data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  uploadAndConsultar(formData) {
    return this.instance.post('/v1/nfe/consultar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  consultarComCertificadoSalvo(data) {
    return this.instance.post('/v1/nfe/certificados/consulta', data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}

export default DigitalCertificatesFactory;
